import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CardActions, CardContent, Grid, Paper, Typography, WarningCircleIcon } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';

const handleClose = () => {
  window.close();
};

// TODO: handle `errorCode` prop for specific error messaging in the future.
const ErrorPage = ({ errorCode, transactionId }) => (
  <Grid
    id="error-page-grid-container"
    container
    display="flex"
    flexDirection="row"
    flexWrap="wrap"
    spacing={0}
    sx={{ minHeight: '100vh', justifyContent: 'center' }}
  >
    <Grid
      size={{ xs: 12, sm: 12, md: 6 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      flexGrow={1}
      sx={{ minHeight: '100vh' }}
    >
      <AvailityHeaderLogo />
      <Grid direction="column" alignItems="center" justifyContent="center">
        <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '700px' } }}>
          <CardContent>
            <Box display="flex">
              <WarningCircleIcon fontSize="xlarge" sx={{ marginTop: 1, marginRight: 2, color: '#C70002' }} />{' '}
              <Box>
                <Typography variant="h1" mb={2}>
                  Oops! We ran into an error.
                </Typography>
                <Typography variant="subtitle1" mb={2}>
                  Please close this tab and try again.
                </Typography>
              </Box>
            </Box>
            <Box mb={2}>
              {errorCode && errorCode !== '0' && (
                <Box>
                  <Box sx={{ fontWeight: 'bold' }}>Code: </Box>
                  {errorCode}
                </Box>
              )}
              {transactionId && (
                <Box>
                  <Box sx={{ fontWeight: 'bold' }}>ID: </Box>
                  {transactionId}
                </Box>
              )}
            </Box>
          </CardContent>
          <CardActions>
            <Button color="primary" onClick={handleClose} sx={{ width: '100%' }}>
              Close
            </Button>
          </CardActions>
        </Paper>
      </Grid>
      <Footer />
    </Grid>
  </Grid>
);

ErrorPage.propTypes = {
  errorCode: PropTypes.string,
  transactionId: PropTypes.string,
};

export default ErrorPage;
